function cov_w4o8l56l() {
  var path = "/app/src/utils/get-installment-period.ts";
  var hash = "f5e4ae7de0828fee7152c47ba3ddf115be2fd952";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/get-installment-period.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 36
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 9,
          column: 3
        }
      },
      "2": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 22
        }
      },
      "3": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 18,
          column: 3
        }
      },
      "4": {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 13,
          column: 22
        }
      },
      "5": {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 66
        }
      },
      "6": {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 17,
          column: 25
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 36
          },
          end: {
            line: 3,
            column: 37
          }
        },
        loc: {
          start: {
            line: 6,
            column: 5
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 6
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 13,
            column: 22
          }
        }, {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 15,
            column: 66
          }
        }, {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 17,
            column: 25
          }
        }],
        line: 11
      },
      "2": {
        loc: {
          start: {
            line: 15,
            column: 13
          },
          end: {
            line: 15,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 15,
            column: 34
          },
          end: {
            line: 15,
            column: 47
          }
        }, {
          start: {
            line: 15,
            column: 50
          },
          end: {
            line: 15,
            column: 65
          }
        }],
        line: 15
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f5e4ae7de0828fee7152c47ba3ddf115be2fd952"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_w4o8l56l = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_w4o8l56l();
cov_w4o8l56l().s[0]++;
export var getInstallmentPeriod = function getInstallmentPeriod(t, period) {
  cov_w4o8l56l().f[0]++;
  cov_w4o8l56l().s[1]++;
  if (!period) {
    cov_w4o8l56l().b[0][0]++;
    cov_w4o8l56l().s[2]++;
    return t('month');
  } else {
    cov_w4o8l56l().b[0][1]++;
  }
  cov_w4o8l56l().s[3]++;
  switch (period.size) {
    case 'day':
      cov_w4o8l56l().b[1][0]++;
      cov_w4o8l56l().s[4]++;
      return t('day');
    case 'week':
      cov_w4o8l56l().b[1][1]++;
      cov_w4o8l56l().s[5]++;
      return period.value === 1 ? (cov_w4o8l56l().b[2][0]++, t('week_one')) : (cov_w4o8l56l().b[2][1]++, t('week_other'));
    default:
      cov_w4o8l56l().b[1][2]++;
      cov_w4o8l56l().s[6]++;
      return t('period');
  }
};